import { useState } from 'react';
import { useNavigate } from 'react-router';
import { Button } from '../components/ui/button';
import { ArrowLeft } from 'lucide-react';
import TimeToClimb from '../components/slides/activity/TimeToClimb';
import type { Slide } from '../../utils/supabase/client';

export default function DemoTimeToClimb() {
  const navigate = useNavigate();
  const [key, setKey] = useState(0);
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [selectedAnswer, setSelectedAnswer] = useState<any>(null);

  // Demo slide data with multiple questions
  const demoSlide: Slide = {
    id: 'demo-time-to-climb',
    lesson_id: 'demo',
    type: 'time_to_climb',
    slide_order: 0,
    created_at: new Date().toISOString(),
    content: {
      timeLimit: 20,
      questions: [
        {
          question: 'What is the largest planet in our solar system?',
          options: ['Earth', 'Jupiter', 'Saturn', 'Neptune'],
          correctAnswer: 1,
        },
        {
          question: 'Which element has the chemical symbol "O"?',
          options: ['Gold', 'Oxygen', 'Osmium', 'Oganesson'],
          correctAnswer: 1,
        },
        {
          question: 'What is the speed of light approximately?',
          options: ['300,000 km/s', '150,000 km/s', '450,000 km/s', '600,000 km/s'],
          correctAnswer: 0,
        },
        {
          question: 'Who painted the Mona Lisa?',
          options: ['Michelangelo', 'Van Gogh', 'Leonardo da Vinci', 'Picasso'],
          correctAnswer: 2,
        },
        {
          question: 'What is the capital of Japan?',
          options: ['Seoul', 'Beijing', 'Bangkok', 'Tokyo'],
          correctAnswer: 3,
        },
      ],
    },
  };

  const handleSubmit = (answer: any) => {
    setHasSubmitted(true);
    setSelectedAnswer(answer);
    console.log('Quiz completed:', answer);
  };

  const handleAnswerChange = (answer: any) => {
    setSelectedAnswer(answer);
  };

  const handleRestart = () => {
    setHasSubmitted(false);
    setSelectedAnswer(null);
    setKey(prev => prev + 1);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-background to-red-50 dark:from-orange-950/20 dark:via-background dark:to-red-950/20">
      {/* Header */}
      <header className="border-b border-border bg-card/80 backdrop-blur-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Button variant="ghost" onClick={() => navigate('/demos')}>
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Demos
            </Button>
            {hasSubmitted && (
              <Button variant="outline" onClick={handleRestart}>
                Try Again
              </Button>
            )}
          </div>
        </div>
      </header>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold mb-2">Time to Climb Demo</h1>
          <p className="text-muted-foreground">
            Race against the clock to answer questions correctly and climb to the top!
          </p>
        </div>

        <TimeToClimb
          key={key}
          slide={demoSlide}
          onSubmit={handleSubmit}
          onAnswerChange={handleAnswerChange}
          selectedAnswer={selectedAnswer}
          hasSubmitted={hasSubmitted}
        />
      </div>
    </div>
  );
}
